import React from 'react';
import './radio-button.css';
import PropTypes from 'prop-types';
import { Paragraph } from '../../paragraph';

const RadioButton = props => {
    const { group, label, addedInfo, onChange, checked } = props;

    return (
        <div className="radio-button">
            <label htmlFor={label} className="radio-button__label">
                <input
                    type="radio"
                    id={label}
                    name={group}
                    value={label}
                    onChange={onChange}
                    className="radio-button__input"
                    checked={checked}
                />
                <span className="radio-button__custom-button" />
                {label}
            </label>
            {addedInfo && (
                <div>
                    <Paragraph withSpacing={false} colorScheme="dark">
                        {addedInfo}
                    </Paragraph>
                </div>
            )}
        </div>
    );
};

RadioButton.propTypes = {
    label: PropTypes.string.isRequired,
    addedInfo: PropTypes.string,
    group: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
};

export { RadioButton };
